import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';

import { ToastComponent } from '../../toast/toast.component';
import { RecordService } from '../../../services/record.service';
import { Record } from '../../models/record.model';
import { ee } from '../../constants';
import { setClassInvalidTpl } from '../../functions';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-edit-record-timesheet-modal',
  templateUrl: './edit-record-timesheet-modal.component.html',
  standalone: false
})
export class EditRecordTimesheetModalComponent implements OnInit, OnDestroy {
  toast = inject(ToastComponent);
  private recordService = inject(RecordService);


  @Input() record: Record = {};

  setClassInvalidTpl = setClassInvalidTpl;

  ngOnInit(): void {
    // This is executed N+1 times, to fix eventually
    ee.on('showEditRecordTimesheetModal', (record: Record) => this.record = record);
  }

  ngOnDestroy(): void {
    ee.off('showEditRecordTimesheetModal', () => {});
  }

  isModalInvalid(): boolean {
    return false;
  }

  updateRecordTimesheet(record: Record): void {
    const update = {
      ...record,
      // Prevent Request Entity Too Large caused by these fields that are already populated
      _user: record._user._id,
      _clients: record._clients.map(client => client._id),
      _politicians: record._politicians.map(politician => politician._id),
      _users: record._users.map(user => user._id),
      _organizations: record._organizations.map(organization => organization._id),
      timesheet: record.timesheet.map(time => ({ ...time, _user: time._user._id })),
    };
    this.recordService.update(update)
      .pipe(finalize(() => {
        ee.emit('getRecords');
        ee.emit('getRecord');
      }))
      .subscribe({
        next: res => this.toast.setMessage('Record timesheet updated successfully.', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

}
